import React, { useContext, useMemo } from 'react';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _isFunction from 'lodash/isFunction';

import { If } from 'utils';
import { ShopperGroupSelector, StickyButtons, UiKit } from 'components';

export default function Actions({
  formData = null,
  initialFormData = null,
  isFetching = false,
  isProcessing = false,
  showDeleteModal = false,
  homeRoute = '',
  onDelete = () => {},
  onOpenDeleteModal = () => {},
  onCloseDeleteModal = () => {},
  onResetForm = null,
  onCancel = null
}) {
  const { selectedOption, onSubmitNew, hasAccess, isConfigurable } = useContext(
    ShopperGroupSelector.Context
  );

  const groupName = _get(selectedOption, 'label', '');
  const isConfigured = _get(selectedOption, 'is_configured', false);

  const isDirty = useMemo(() => {
    return _isEqual(formData, initialFormData);
  }, [formData, initialFormData]);

  const disableSaveButton = isDirty && isConfigured;

  return (
    <>
      <StickyButtons
        alwaysEdit
        data={formData}
        initialData={initialFormData}
        helptext={
          <If test={hasAccess && isConfigurable && groupName}>
            Currently Configuring - <b>{groupName}</b>
          </If>
        }
      >
        {_isFunction(onCancel) && (
          <UiKit.Button
            size="lg"
            variant="outline"
            onClick={onCancel}
            disabled={isFetching || isProcessing}
          >
            Cancel
          </UiKit.Button>
        )}
        {_isFunction(onResetForm) && (
          <UiKit.Button
            size="lg"
            variant="outline"
            onClick={onResetForm}
            disabled={isFetching || isProcessing}
          >
            Reset
          </UiKit.Button>
        )}
        {isConfigured && (
          <UiKit.Button
            size="lg"
            variant="destructive"
            onClick={onOpenDeleteModal}
            disabled={isFetching || isProcessing}
          >
            Delete
          </UiKit.Button>
        )}
        <UiKit.Button
          size="lg"
          onClick={onSubmitNew}
          disabled={disableSaveButton || isFetching}
          processing={isProcessing}
        >
          Save Changes
        </UiKit.Button>
      </StickyButtons>
      <UiKit.Modal isOpen={showDeleteModal} onClose={onCloseDeleteModal}>
        <UiKit.Modal.Header title="Delete customer group" />
        <UiKit.Modal.Body>
          <div>
            Are you sure you want to delete configurations for this{' '}
            <b>{groupName}</b> customer group?
          </div>
        </UiKit.Modal.Body>
        <UiKit.Modal.Footer
          onConfirm={() => onDelete(onCloseDeleteModal)}
          confirmBtnText="Delete group"
          confirmBtnVariant="destructive"
        />
      </UiKit.Modal>
    </>
  );
}
